import { Component, OnInit } from "@angular/core";
import { SharedService } from "../../services/shared.service";
import { TokenService } from "../../../core/tokenManagement/token.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-toolbar",
  templateUrl: "./toolbar.component.html",
  styleUrls: ["./toolbar.component.css"],
})
export class ToolbarComponent implements OnInit {
  // userLocalDetails: any;

  constructor(private tokenservice: TokenService, private router: Router) {}

  ngOnInit() {
    // this.getLocalDetails();
  }

  // async getLocalDetails() {
  //   console.log("howfar here ");
  //   this.userLocalDetails = await this.tokenservice.getUserCred();
  //   this.verifyUserDetails(this.userLocalDetails);
  //   console.log(this.userLocalDetails["permissions"]);
  // }

  // verifyUserDetails(user) {
  //   console.log(user["permissions"]);
  //   console.log("wjo am iiiiii");

  //   if (
  //     user["permissions"].includes("MANAGE_PAYMENT_PAGES") ||
  //     user["permissions"].includes("CREATE_CLIENT_USERS") ||
  //     user["permissions"].includes("CREATE_DISBURSEMENT")
  //   ) {
  //     if (
  //       !user.bankAccountNumber ||
  //       !user.bankAccountName ||
  //       !user.bankAccountCode
  //     ) {
  //       this.router.navigate(["/profile/business"]);
  //     }
  //   } else return;
  // }
}
